import { render, staticRenderFns } from "./inbound-graph-widget.vue?vue&type=template&id=4c4ec9fa"
import script from "./inbound-graph-widget.vue?vue&type=script&lang=js"
export * from "./inbound-graph-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports